import { Box, Button } from "@mui/material";
import React from "react";

function SubmitButton({ onClick, label = "Ekle" }) {
  return (
    <Box paddingX={1} display="flex" justifyContent="flex-end" >
      <Button variant="contained" onClick={onClick}>
        {label}
      </Button>
    </Box>
  );
}

export default SubmitButton;
